import { Stack, Typography } from '@mui/material'
import { useConvertContext } from '@plug-core/providers/ConvertProvider'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import ExchangeReview from '@modules/Swap/Components/ExchangeReview'
import { ROUTES } from '@utils/routes'
import RainbowTextField from '@components/RainbowTextField/RainbowTextField'
import useConvertReview from '@plug-core/hooks/useConvertReview'

interface Props {
  onError?: (error: string) => void
}

const ConvertReview: FC<Props> = ({ onError }) => {
  const navigate = useNavigate()

  const { fromToken, toToken, amount, toAmount } = useConvertContext()

  const {
    loading,
    convert,
    requiresAddressInput,
    destinationAddress,
    setDestinationAddress,
    error,
    destinationAddressValid,
  } = useConvertReview({
    onError,
    onSuccess: (converId) =>
      navigate(ROUTES.CONVERT_RESULT, {
        state: { id: converId },
        replace: true,
      }),
  })

  const { t } = useTranslation()

  const renderAddressInput = () => {
    if (!requiresAddressInput) return

    return (
      <Stack spacing={1} mt={2}>
        <Typography>
          {t('convert.enterAddress', {
            currency: toToken?.symbol,
          })}
        </Typography>
        <RainbowTextField
          placeholder={t('common.address')}
          value={destinationAddress}
          onChange={({ target: { value } }) => setDestinationAddress(value)}
          error={!destinationAddressValid}
        />
      </Stack>
    )
  }

  return (
    <ExchangeReview
      fromTokenImage={fromToken?.logo}
      toTokenImage={toToken?.logo}
      fromTokenSymbol={fromToken?.symbol}
      toTokenSymbol={toToken?.symbol}
      amount={amount}
      toAmount={toAmount}
      buttonTitle={error ? error : 'Convert'}
      handleSubmit={convert}
      loading={loading}
      error={error}
      kind="convert"
    >
      {renderAddressInput()}
    </ExchangeReview>
  )
}

export default ConvertReview
